<div class="city-container ">
    <a [routerLink]="[cityObj.routerLink]">
        <img [src]="cityObj.imgUrl" class="city-img fade-in-image">
        <h1 class="city-title">{{cityObj.name}}</h1>
    </a>
    
</div>